import React, { useState, useEffect } from 'react';
import LegalTextEditor from './LegalTextEditor';

const OptionsPage = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [switching, setSwitching] = useState(false);
  const [toast, setToast] = useState(null);
  const [confirmStripe, setConfirmStripe] = useState(null);

  const csrf = () => document.querySelector('[name="csrf-token"]')?.content;

  const showToast = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 5000);
  };

  useEffect(() => { loadSettings(); }, []);

  const loadSettings = async () => {
    try {
      const res = await fetch('/api/v1/settings', {
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf() }
      });
      if (res.status === 403) {
        setSettings('forbidden');
        return;
      }
      const data = await res.json();
      if (data.success) setSettings(data.settings);
    } catch (e) {
      console.error(e);
      showToast('Erreur lors du chargement des paramètres', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStripe = async (mode) => {
    setSwitching(true);
    try {
      const res = await fetch('/api/v1/settings/toggle_stripe_mode', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf() },
        body: JSON.stringify({ mode })
      });
      const data = await res.json();
      if (data.success) {
        setSettings(prev => ({ ...prev, stripe_mode: data.stripe_mode, stripe_publishable_key: data.stripe_publishable_key }));
        showToast(data.message);
      } else {
        showToast(data.message, 'error');
      }
    } catch { showToast('Erreur réseau', 'error'); }
    finally { setSwitching(false); setConfirmStripe(null); }
  };

  if (loading) return (
    <div style={{ background: '#f7eef2', minHeight: '100vh', paddingTop: 140, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 48, height: 48, border: '4px solid rgba(124,40,55,0.2)', borderTop: '4px solid #7c2837', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  if (settings === 'forbidden') return (
    <div style={{ background: '#f7eef2', minHeight: '100vh', paddingTop: 140, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 24 }}>
      <div style={{ fontSize: '4rem' }}>🔒</div>
      <h2 style={{ color: '#2c0e16', fontWeight: 800, margin: 0 }}>Accès réservé</h2>
      <p style={{ color: '#7a4050', fontSize: '1rem' }}>Cette page est réservée aux membres fondateurs.</p>
      <a href="/" style={{ background: 'linear-gradient(135deg,#7c2837,#a8384e)', color: '#fff', padding: '12px 28px', borderRadius: 10, textDecoration: 'none', fontWeight: 700 }}>← Retour à l'accueil</a>
    </div>
  );

  const isLive = settings?.stripe_mode === 'live';

  return (
    <div style={{ background: '#f7eef2', minHeight: '100vh', paddingTop: 100, paddingBottom: 80, fontFamily: 'inherit' }}>
      {/* Toast */}
      {toast && (
        <div style={{ position: 'fixed', top: 24, right: 24, zIndex: 9999, background: toast.type === 'error' ? '#7c1c2a' : '#1a3a2a', border: `1px solid ${toast.type === 'error' ? '#c0392b' : '#27ae60'}`, color: '#fff', padding: '14px 24px', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.3)', fontWeight: 600, fontSize: '0.95rem', maxWidth: 380 }}>
          {toast.type === 'error' ? '❌' : '✅'} {toast.message}
        </div>
      )}

      {/* Modal confirmation Stripe */}
      {confirmStripe && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(44,14,22,0.5)', zIndex: 9998, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <div style={{ background: '#fff', borderRadius: 20, padding: 32, maxWidth: 480, width: '100%', boxShadow: '0 24px 64px rgba(44,14,22,0.25)' }}>
            <h3 style={{ color: '#2c0e16', margin: '0 0 12px', fontWeight: 800, fontSize: '1.2rem' }}>
              {confirmStripe === 'live' ? '⚠️ Passer en mode LIVE' : '🔄 Revenir en mode TEST'}
            </h3>
            <p style={{ color: '#7a4050', margin: '0 0 10px', fontSize: '0.95rem', lineHeight: 1.7 }}>
              {confirmStripe === 'live'
                ? 'En mode live, les paiements seront réels. Les cartes bancaires des membres seront débitées. Êtes-vous sûr(e) de vouloir continuer ?'
                : 'En mode test, les paiements utiliseront des cartes de test Stripe. Aucun débit réel ne sera effectué.'
              }
            </p>
            {confirmStripe === 'live' && (
              <div style={{ padding: '12px 16px', background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 10, marginBottom: 18, fontSize: '0.87rem', color: '#dc2626', fontWeight: 600 }}>
                ⚠️ Cette action affecte immédiatement tous les paiements de l'application.
              </div>
            )}
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 20 }}>
              <button onClick={() => setConfirmStripe(null)} style={{ background: '#fdf6f8', border: '1px solid rgba(124,40,55,0.2)', color: '#2c0e16', padding: '10px 22px', borderRadius: 10, cursor: 'pointer', fontWeight: 600 }}>Annuler</button>
              <button
                onClick={() => handleToggleStripe(confirmStripe)}
                disabled={switching}
                style={{ background: confirmStripe === 'live' ? '#dc2626' : 'linear-gradient(135deg,#7c2837,#a8384e)', border: 'none', color: '#fff', padding: '10px 22px', borderRadius: 10, cursor: switching ? 'not-allowed' : 'pointer', fontWeight: 700 }}
              >
                {switching ? '⏳ En cours…' : confirmStripe === 'live' ? 'Confirmer le passage en LIVE' : 'Confirmer le retour en TEST'}
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 24px' }}>
        {/* Header */}
        <div style={{ marginBottom: 32 }}>
          <a href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: '#7a4050', textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem', marginBottom: 20, padding: '8px 16px', background: '#fff', borderRadius: 10, border: '1px solid rgba(124,40,55,0.15)' }}>
            ← Retour à l'accueil
          </a>
          <h1 style={{ color: '#2c0e16', fontSize: 'clamp(1.8rem, 4vw, 2.4rem)', fontWeight: 800, margin: '16px 0 8px', letterSpacing: '-0.03em' }}>⚙️ Options</h1>
          <p style={{ color: '#7a4050', fontSize: '1rem', margin: 0 }}>Paramètres réservés aux membres fondateurs</p>
        </div>

        {/* ── Stripe Mode ──────────────────────────────── */}
        <div style={{ background: '#fff', borderRadius: 20, border: '1px solid rgba(124,40,55,0.10)', padding: '28px 32px', marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16, marginBottom: 20 }}>
            <div>
              <h2 style={{ color: '#2c0e16', fontSize: '1.2rem', fontWeight: 800, margin: '0 0 6px', display: 'flex', alignItems: 'center', gap: 10 }}>
                💳 Mode Stripe
              </h2>
              <p style={{ color: '#7a4050', fontSize: '0.9rem', margin: 0 }}>
                Basculez entre les clés de test et les clés de production Stripe
              </p>
            </div>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '8px 16px', borderRadius: 999,
              background: isLive ? '#fef2f2' : '#f0fdf4',
              border: `1px solid ${isLive ? '#fca5a5' : '#86efac'}`,
              fontWeight: 700, fontSize: '0.88rem',
              color: isLive ? '#dc2626' : '#15803d'
            }}>
              {isLive ? '🔴 LIVE' : '🟢 TEST'}
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
            {[
              { label: 'Mode actuel', val: isLive ? 'Production (LIVE)' : 'Test', color: isLive ? '#dc2626' : '#15803d' },
              { label: 'Clé publique', val: settings?.stripe_publishable_key ? `${settings.stripe_publishable_key.slice(0, 12)}...${settings.stripe_publishable_key.slice(-4)}` : '—' },
              { label: 'Environnement Rails', val: settings?.rails_env },
            ].map((row, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid rgba(124,40,55,0.07)' }}>
                <span style={{ color: '#7a4050', fontSize: '0.88rem' }}>{row.label}</span>
                <span style={{ color: row.color || '#2c0e16', fontWeight: 600, fontSize: '0.88rem', fontFamily: row.label === 'Clé publique' ? 'monospace' : 'inherit' }}>{row.val}</span>
              </div>
            ))}
          </div>

          {isLive ? (
            <button
              onClick={() => setConfirmStripe('test')}
              disabled={switching}
              style={{ width: '100%', background: '#f0fdf4', border: '2px solid #86efac', borderRadius: 12, padding: '14px', color: '#15803d', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' }}
            >
              🔄 Repasser en mode TEST
            </button>
          ) : (
            <button
              onClick={() => setConfirmStripe('live')}
              disabled={switching}
              style={{ width: '100%', background: '#fef2f2', border: '2px solid #fca5a5', borderRadius: 12, padding: '14px', color: '#dc2626', fontWeight: 700, fontSize: '1rem', cursor: 'pointer' }}
            >
              🚀 Passer en mode LIVE
            </button>
          )}
        </div>

        {/* ── Infos système ──────────────────────────────── */}
        <div style={{ background: '#fff', borderRadius: 20, border: '1px solid rgba(124,40,55,0.10)', padding: '28px 32px', marginBottom: 24 }}>
          <h2 style={{ color: '#2c0e16', fontSize: '1.2rem', fontWeight: 800, margin: '0 0 20px', display: 'flex', alignItems: 'center', gap: 10 }}>
            🖥️ Informations système
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {[
              { label: 'Environnement', val: settings?.rails_env, icon: '🌍' },
              { label: 'Domaine', val: settings?.app_domain, icon: '🔗' },
              { label: 'Stockage fichiers', val: settings?.active_storage_service, icon: '📦' },
            ].map((row, i, arr) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 0', borderBottom: i < arr.length - 1 ? '1px solid rgba(124,40,55,0.07)' : 'none' }}>
                <span style={{ fontSize: '1.1rem' }}>{row.icon}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ color: '#9e6575', fontSize: '0.76rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 2 }}>{row.label}</div>
                  <div style={{ color: '#2c0e16', fontWeight: 600, fontSize: '0.92rem' }}>{row.val || '—'}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Textes légaux ──────────────────────────────── */}
        <div style={{ background: '#fff', borderRadius: 20, border: '1px solid rgba(124,40,55,0.10)', padding: '28px 32px', marginBottom: 24 }}>
          <h2 style={{ color: '#2c0e16', fontSize: '1.2rem', fontWeight: 800, margin: '0 0 20px', display: 'flex', alignItems: 'center', gap: 10 }}>
            📜 Textes légaux
          </h2>
          <p style={{ color: '#7a4050', fontSize: '0.9rem', margin: '0 0 20px' }}>
            Gérez les textes du droit à l'image et du règlement intérieur affichés lors des inscriptions aux événements.
          </p>
          <LegalTextEditor />
        </div>

        {/* ── Liens rapides ──────────────────────────────── */}
        <div style={{ background: '#fff', borderRadius: 20, border: '1px solid rgba(124,40,55,0.10)', padding: '28px 32px' }}>
          <h2 style={{ color: '#2c0e16', fontSize: '1.2rem', fontWeight: 800, margin: '0 0 20px', display: 'flex', alignItems: 'center', gap: 10 }}>
            🔗 Liens rapides
          </h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
            {[
              { label: '📊 Dashboard admin', href: '/admin/dashboard' },
              { label: '📅 Événements', href: '/events' },
              { label: '👥 Parrainages', href: '/admin/sponsorships' },
              { label: '💰 Stripe Dashboard', href: isLive ? 'https://dashboard.stripe.com' : 'https://dashboard.stripe.com/test', external: true },
            ].map((link, i) => (
              <a
                key={i}
                href={link.href}
                target={link.external ? '_blank' : undefined}
                rel={link.external ? 'noopener noreferrer' : undefined}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  padding: '10px 20px', borderRadius: 12,
                  background: '#fdf6f8', border: '1px solid rgba(124,40,55,0.12)',
                  color: '#7c2837', textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem'
                }}
              >
                {link.label} {link.external ? '↗' : ''}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptionsPage;
